import styled from 'styled-components';
import media from 'styled-media-query';

export const Wrapper = styled.div`
  width: 436px;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 100%;

    div {
      max-width: 28rem;
      main {
        max-width: 100%;
      }
    }
  }

  ${media.lessThan('small')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 100%;

    div {
      max-width: 28rem;
      main {
        max-width: 100%;
      }
    }
    `}
`;

export const DivInput = styled.div`
  display: grid;
  grid-template-columns: 252px 156px;
  width: 436px;
  grid-gap: 28px;
  grid-row-gap: 20px;
  ${media.lessThan('large')`
    height: auto;
    grid-template-columns: 1.5fr 1fr;
    grid-gap: 2rem;
  `}
  @media only screen and (max-width: 1000px) {
    height: auto;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    align-items: center;
  }
  ${media.lessThan('small')`
    height: auto;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    align-items: center;
  `}

  main {
    margin-top: 0;

    label {
      padding-left: 8px;
    }

    input {
      font-size: 14px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      padding-left: 8px;
      padding-bottom: 3px;
    }
  }
`;

export const Container = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

export const SocioWrapper = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContentContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 8px;
  margin-bottom: 16px;
  max-height: 230px;
  overflow-y: auto;
`;

export const SocioNome = styled.div`
  width: 60%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
  padding-left: 12px;
`;

export const SocioParticipacao = styled.div`
  width: 80px;
  font-size: 13px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  & main {
    margin-top: 0px;
    margin: 0;
    & input {
      font-size: 13px;
      border: 1px solid #ccc;
      border-radius: 5px;
      text-align: center;
    }
    & p {
      bottom: 0;
    }
    & div {
      bottom: 1.5rem;
    }
  }
`;
export const SocioAcao = styled.div`
  width: 10%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export const AddContainer = styled.div``;
export const SocioCpf = styled.input``;
export const SocioAdd = styled.button``;
export const SemSocios = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-family: Roboto;
  color: #555;
  font-size: 14px;

  padding: 8px;
`;
export const TextLine = styled.span`
  margin-top: 4px;
`;
